module.exports = __webpack_public_path__ + "img/bar-1.225ee1ef.png";